import { Component, OnInit,Input, ElementRef, ViewChild,ViewChildren, QueryList } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.page.html',
  styleUrls: ['./comment.page.scss'],
})
export class CommentPage implements OnInit {
  @Input() file: any = null;

  comments: any = null;
  current_user: any = null;
  comment: any = {
    reply_to: null,
    reply_to_text: null,
    comment: ''
  }
  constructor(private apiService: ApiService,public globalService: GlobalService,private modalController: ModalController) { }

  ngOnInit() { 
    this.GetCurrentUser(); 
    this.Get();
  }
  
  async GetCurrentUser() {
    this.current_user = await this.globalService.GetUser();
  }

  //Get all the comments for a file
  async Get() {
    let data: any = await this.apiService.get(`files/comments/${this.file.guid}`);
    if(data.success) {
      if(data.data)
        this.comments = data.data;
      else
        this.comments = [];
    }
    
  }

  //Create a comment and add it to the list
  async CreateComment() {
    let data: any = await this.apiService.post(`files/comments/${this.file.guid}`,this.comment);
    if(data.success) {
      let comment_to_push = data.data[0];
      comment_to_push.users = [];
      comment_to_push.users.push({display_name:this.current_user.display_name});
      this.comments.unshift(comment_to_push);
      this.comment.comment = '';
      this.comment.reply_to = null;
      this.comment.reply_to_text = null;
    }
    this.globalService.presentToastMessage(data.message,data.success);
  }

  //Setup the ability to reply
  async StartReplyTo(comment) {
    this.comment.reply_to = comment.guid;
    this.comment.reply_to_name = comment.users[0].display_name;
    this.comment.reply_to_text = comment.comment;
  }

  //Cancel replying to a comment
  async CancelReply() {
    this.comment.reply_to = null;
    this.comment.reply_to_name = null;
    this.comment.reply_to_text = null;
  }

  async DeleteComment(comment) {
    let data: any = await this.apiService.delete(`files/comments/${comment.guid}`,null);
    if (data.success) {
      var index = this.comments.findIndex(item => item.guid === comment.guid);
      this.comments.splice(index, 1);
    }
    this.globalService.presentToastMessage(data.message, data.success);
  }

  async Dismiss() {
    this.modalController.dismiss();
  }

}
